/* import __COLOCATED_TEMPLATE__ from './bandpass-inductor.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();